import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import "./ChatsOverviewReport.css";
import "primeflex/primeflex.css";
import moment from "moment";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { wglcsApiService } from "../../../services/WglcsApiService";
import { LoginResponse } from "../../../models/index";
import TotalChats from "../../../views/report/TotalChats";
import TotalDuration from "../../../views/report/TotalDuration";
import TotalAgentsChat from "../../../views/report/TotalAgentsChat";
import ChatResponseTime from "../../../views/report/ChatResponseTime";
import ChatAvailability from "../../../views/report/ChatAvailability";
import { ProgressSpinner } from "primereact/progressspinner";
import { Calendar } from "primereact/calendar";

import _ from "lodash";
import { Skeleton } from "primereact/skeleton";
import SkeletonView from "../../../views/report/SkeletonView";
import { utils } from "../../../utils";
import EventEmitter, { Events } from "../../../services/eventemitter";
import { Ripple } from "primereact/ripple";
import RefereshApi from "../../../components/refereshApi/refereshApi.component";
import { t } from "i18next";

interface reportComponentState {
    loading: boolean;
    tableloading: boolean;
    websites: any | [];
    selectedWebsite: [];
    TotalDays: [];
    websiteId: number;
    fromDate: Date | any;
    toDate: Date | any;
    dayWiseReport: any | [];
    hoursWiseReport: [];
    userWiseReport: [];
    chatResponseReport: [];
    firstIndex: [];
    firstId: number;
    BtnDisabled: boolean;
    resetReports: boolean;
    skeletonLength: any[];
    minDate: Date;
    maxDate: Date;
}

class ChatOverviewReport extends Component<{}, reportComponentState> {
    constructor(props) {
        super(props);

        // var fDate = moment(new Date().setDate(new Date().getDate() - 5)).format('YYYY-MM-DD');
        // var tDate = moment(new Date().setDate(new Date().getDate() - 1)).format('YYYY-MM-DD');

        var fDate = new Date();
        fDate.setDate(fDate.getDate() - 5);

        var tDate = new Date();
        tDate.setDate(tDate.getDate() - 1);

        this.state = {
            loading: true,
            tableloading: true,
            websites: [] as any,
            selectedWebsite: [] as any,
            TotalDays: [],
            websiteId: 0,
            fromDate: fDate,
            toDate: tDate,
            dayWiseReport: [] as any,
            hoursWiseReport: [] as any,
            userWiseReport: [] as any,
            chatResponseReport: [] as any,
            firstIndex: [] as any,
            firstId: 0,
            BtnDisabled: true,
            resetReports: false,
            skeletonLength: [{ name: "" }, { name: "" }, { name: "" }, { name: "" }, { name: "" }, { name: "" }],
            minDate: new Date(),
            maxDate: new Date(),
        };

        EventEmitter.on(Events.passDataToChilds, this.onLoadWebsites);
    }

    componentWillUnmount() {
        EventEmitter.off(Events.passDataToChilds, this.onLoadWebsites);
    }

    handleFromDate = (e) => {
        var fDate = moment(e.value).format("YYYY-MM-DD");
        this.setState({
            fromDate: fDate as any,
            minDate: e.value as any,
        } as reportComponentState);
    };

    handleToDate = (e) => {
        var tDate = moment(e.value).format("YYYY-MM-DD");
        this.setState({
            toDate: tDate as any,
        } as reportComponentState);
    };

    handleWebsite = (value) => {
        this.setState({
            websiteId: value.websiteId,
            selectedWebsite: value,
        } as reportComponentState);
    };

    componentDidMount() {
        let TempArray = [{ id: 2, name: "temp" }];
        this.setState({
            websites: TempArray,
        } as reportComponentState);
        EventEmitter.emit(Events.requestForWebsiteData, "");
    }

    getDates = (fromDate, toDate) => {
        var dateArray = [] as any;
        var currentDate = moment(fromDate);
        var stopDate = moment(toDate) as any;
        while (currentDate <= stopDate) {
            dateArray.push(moment(currentDate).format("DD-MMM"));
            currentDate = moment(currentDate).add(1, "days");
        }
        return dateArray;
    };

    onLoadWebsites = (data) => {
        if (!data?.loader && data?.data?.length > 0) {
            var orderByWebsite = utils.arraySorting("domainName", data?.data);
            this.setState({
                websites: orderByWebsite,
                loading: false,
                BtnDisabled: false,
                selectedWebsite: orderByWebsite[0] as any,
                firstIndex: orderByWebsite[0] as any,
                websiteId: orderByWebsite[0]?.websiteId,
                firstId: orderByWebsite[0]?.websiteId,
            } as reportComponentState);

            this.getReportData(orderByWebsite[0]?.websiteId, this.state.fromDate, this.state.toDate);
        } else if (!data?.loader && !(data?.data?.length > 0)) {
            this.setState({
                loading: false,
                tableloading: false,
                websites: [],
            });
        }
    };

    getReportData = async (selectedWebsiteId, fromDate, toDate) => {
        this.setState({
            tableloading: true,
        });

        var fDate = moment(fromDate).format("YYYY-MM-DD");
        var tDate = moment(toDate).format("YYYY-MM-DD");

        const body = {
            fromDate: fDate,
            toDate: tDate,
            websiteId: selectedWebsiteId?.toString(),
        };

        this.getDayWiseResport(body);

        const [hourswiseResponse, depdashboardwebsitestats_comanaged, useriseResponse] = await Promise.all([
            wglcsApiService.depdashboard_websitestats_hourwise(body),
            wglcsApiService.depdashboardwebsitestats_comanaged(body),
            wglcsApiService.depdashboard_websitestats_userwise(body),
        ]);

        // let hourswiseResponse = await wglcsApiService.depdashboard_websitestats_hourwise(body);
        // let daywiseResponse = await wglcsApiService.depdashboard_websitestats_daywise(body);
        // let depdashboardwebsitestats_comanaged = await wglcsApiService.depdashboardwebsitestats_comanaged(body);
        // let useriseResponse = await wglcsApiService.depdashboard_websitestats_userwise(body);

        this.setState({
            userWiseReport: useriseResponse?.data!.data as any,
            hoursWiseReport: hourswiseResponse?.data!.data as any,
            chatResponseReport: depdashboardwebsitestats_comanaged?.data!.data as any,
            tableloading: false,
        });
    };

    getDayWiseResport = async (body) => {
        const daywiseResponse = await wglcsApiService.depdashboard_websitestats_daywise(body);
        this.setState({ dayWiseReport: daywiseResponse?.data!.data as any });
    };

    WebsiteOptionTemplate = (option) => {
        // if (this.state.loading) {
        //     return (
        //         <>
        //             <div style={{ marginTop: "15px" }}>
        //                 <Skeleton style={{ marginTop: 10 }}></Skeleton>
        //             </div>
        //         </>
        //     );
        // }

        if (option) {
            return (
                <div className="country-item">
                    <div>{option.domainName}</div>
                </div>
            );
        }
    };

    Clear = () => {
        this.setState({ fromDate: "", toDate: null });
    };

    handleState = () => {
        var fDate = new Date();
        fDate.setDate(fDate.getDate() - 5);

        var tDate = new Date();
        tDate.setDate(tDate.getDate() - 1);
        var ffDate = moment(fDate).format("YYYY-MM-DD");

        this.setState(
            {
                websiteId: this.state.firstId,
                fromDate: fDate,
                // toDate: tDate,
                selectedWebsite: this.state.firstIndex,
            },
            () => {}
        );
    };

    renderLoader = () => {
        return (
            <div className="" style={{ marginTop: "-41px", marginLeft: "14px" }}>
                <ProgressSpinner strokeWidth="3" fill="#EEEEEE" style={{ height: "20px", width: "20px" }} animationDuration=".5s" />
            </div>
        );
    };

    render() {
        return (
            <Fragment>
                <div className="p-grid- view-report row p-2">
                    <div className="wgreport-tab viewreport-box">
                        <div className="row view-wgreport">
                        <div className="col-12 col-md-12 col-lg-4 py-1 wgreport">
                            <label className="wgreport-label" htmlFor="basic">{t("ReportComponent.Website")}</label>
                            <Dropdown
                                className="form-control"
                                filter
                                filterBy="domainName"
                                showFilterClear
                                showClear
                                style={{ display: "flex" }}
                                value={this.state.selectedWebsite}
                                options={this.state.websites}
                                itemTemplate={this.WebsiteOptionTemplate}
                                onChange={(e) => this.handleWebsite(e.target.value)}
                                optionLabel="domainName"
                                placeholder={!this.state.loading ? t("ReportComponent.Select Website") : ""}
                            />
                            {this.state.loading && this.renderLoader()}
                        </div>

                        <div className="col-12 col-md-6 col-lg-4 py-1 wgreport">
                            <label className="wgreport-label" htmlFor="basic">{t('ChatTranscriptComponent.From Date')}</label>
                            
                            {/* <Calendar showIcon value={this.state.fromDate} onChange={this.handleFromDate} /> */}
                            <Calendar
                                showIcon
                                value={this.state.fromDate}
                                maxDate={this.state.maxDate}
                                onChange={this.handleFromDate}
                                monthNavigator
                                yearNavigator
                                yearRange="2000:2050"
                            />
                        </div>

                        <div className="col-12 col-md-6 col-lg-4 py-1 wgreport">
                            <label className="wgreport-label" htmlFor="basic">{t('ChatTranscriptComponent.To Date')}</label>
                            
                            <Calendar
                                id="abc"
                                showIcon
                                value={this.state.toDate}
                                onChange={this.handleToDate}
                                minDate={this.state.minDate}
                                maxDate={this.state.maxDate}
                                monthNavigator
                                yearNavigator
                                yearRange="2000:2050"
                            />
                        </div>

                        <div className="col-12 py-sm-1">
                            <div style={{ float: "right" }}>
                                <button
                                    // disabled={selectedWebsite == null ? true : false}
                                    className="search-btn wgbtn p-ripple my-0"
                                    onClick={() => this.getReportData(this.state.websiteId?.toString(), this.state.fromDate, this.state.toDate)}
                                    title={t("wg-buttons.View-Report")}
                                >
                                    {t("wg-buttons.View-Report")}
                                </button>
                                {/* <button
                                    className="clear-btn wgclear-btn p-ripple"
                                    disabled={this.state.BtnDisabled}
                                    onClick={(e) => {
                                        this.Clear();
                                    }}
                                >
                                    <Ripple /> {t("wg-buttons.Clear")}
                                </button> */}
                            </div>
                        </div>
                        </div>
                        
                    </div>

                    <div className="wgreport-tab viewreport-box">
                    <div className="row">
                            {this.state.tableloading == true ? (
                                <SkeletonView />
                            ) : (
                                <>
                                    <div className="p-col-12 p-md-6 p-lg-6 p-sm-12 p-xs-12 pl-0">
                                        <Card>
                                            <div className="p-grid">
                                                <div className="p-col-1 p-md-1 p-lg-1 p-sm-1 p-col-align-center">
                                                    <h6 className="verticle">{t("ReportComponent.Chats")}</h6>
                                                </div>
                                                <div className="p-col-11 p-md-11 p-lg-11 p-sm-11">
                                                    {this.state.websites?.length == 0 && !this.state.tableloading ? (
                                                        <div className="card"> </div>
                                                    ) : (
                                                        <TotalChats loading={this.state.dayWiseReport?.length} data={this.state.dayWiseReport} />
                                                    )}
                                                </div>
                                            </div>
                                        </Card>
                                    </div>

                                    <div className="p-col-12 p-md-6 p-lg-6 p-sm-12 p-xs-12 pr-0">
                                        <Card>
                                            <div className="p-grid">
                                                <div className="p-col-1 p-md-1 p-lg-1 p-sm-1 p-col-align-center">
                                                    <h6 className="verticle">{t("ReportComponent.Minutes")}</h6>
                                                </div>
                                                <div className="p-col-11 p-md-11 p-lg-11 p-sm-11">
                                                    <TotalDuration loading={this.state.tableloading} data={this.state.dayWiseReport} />
                                                </div>
                                            </div>
                                        </Card>
                                    </div>

                                    <div className="p-col-12 p-md-6 p-lg-6 p-sm-12 p-xs-12 pl-0">
                                        <Card>
                                            <ChatResponseTime loading={this.state.tableloading} data={this.state.chatResponseReport} />
                                        </Card>
                                    </div>

                                    <div className="p-col-12 p-md-6 p-lg-6 p-sm-12 p-xs-12 pr-0">
                                        <Card className="chat-avail-chart">
                                            <div className="p-grid">
                                                <div className="p-col-1 p-md-1 p-lg-1 p-sm-1 p-col-align-center">
                                                    <h6 className="verticle">{t("ReportComponent.Hours")}</h6>
                                                </div>
                                                <div className="p-col-11 p-md-11 p-lg-11 p-sm-11">
                                                    <ChatAvailability dayWiseReportData={this.state.dayWiseReport} />
                                                </div>
                                            </div>
                                        </Card>
                                    </div>

                                    <div className="p-col-12 p-md-6 p-lg-6 p-sm-12 p-xs-12 pl-0">
                                        <Card>
                                            <TotalAgentsChat data={this.state.userWiseReport} heading={t("ReportComponent.Total Chats By Agents")} />
                                        </Card>
                                    </div>
                                </>
                            )}
                        </div>
                        </div>
                </div>
            </Fragment>
        );
    }
}
export default ChatOverviewReport;
